var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/_opy_VqP/0/cw/ws/uvocorp.com/gatsby/~/core-js/library/modules/_has.js
// module id = 33
// module chunks = 168707334958949